import { render, staticRenderFns } from "./promactiQueryList.vue?vue&type=template&id=da23f31e&"
import script from "./promactiQueryList.vue?vue&type=script&lang=js&"
export * from "./promactiQueryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports